var map = {
	"./barrackech.jpg": "7002",
	"./becomb.jpg": "de8c",
	"./biblioteca-municipal.jpg": "0a85",
	"./camara-municipal.jpg": "bf97",
	"./casa-artesao.jpg": "9aba",
	"./casa-parochial.jpg": "4973",
	"./colegio-modelo.jpg": "901a",
	"./escola-parochial.jpg": "394b",
	"./estaca-ferroviaria.jpg": "6dd3",
	"./estrada-parque-piraputanga.jpg": "5b50",
	"./feira-indigena.jpg": "d1b0",
	"./hotel-baia-pedras.jpg": "4ad4",
	"./hotel-barra-mansa.jpg": "6aa7",
	"./igreja-matriz.jpg": "a3d1",
	"./lagoa-comprida.jpg": "f27d",
	"./mercado-municipal.jpg": "173c",
	"./mirante-paxixi.jpg": "2ea5",
	"./museu-arte-pantaneira.jpg": "e842",
	"./museu-arte2.jpeg": "cddc",
	"./museu-marechal-jose-machado.jpg": "e883",
	"./pantanal.jpg": "4b6d",
	"./ponte-velha.jpg": "129f",
	"./pousada-aguape.jpg": "9d46",
	"./pousada-barranco-alto.jpg": "4386",
	"./pousada-pequi.jpg": "1852",
	"./pousada-pesqueiro-caranda.jpg": "dc68",
	"./praca-estudantes.jpg": "4fb2",
	"./praca-matriz.jpg": "8615",
	"./rio-aquidauana.jpg": "ff5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cd58";